import React from 'react'
import { translate } from 'locales/index'
import * as S from './styles'

const TotalPassBadge: React.FC = () => {
  return (
    <S.Badge>
      <span className="dot" />
      <span className="label">{translate('home.totalPassBadge')}</span>
    </S.Badge>
  )
}

export default TotalPassBadge
